export const DATE_TIME_FORMAT = 'MMM D, YYYY h:mm A';
